<header *ngIf="isAuthenticated">
  <nav class="navbar navbar-expand-md fixed-top">
    <a class="navbar-brand" [routerLinkActive]="['router-link-active']" [routerLink]="['/']">
      <mat-icon class="logo" svgIcon="altarea" routerLink="/"></mat-icon>
      <span class="logo-text">E-Fac</span>
    </a>
    <div class="divider"></div>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarCollapse">
      <ul class="navbar-nav mr-auto" *ngIf="showMenu">
        <li class="nav-item" *ngIf="showControl">
          <a class="nav-link" [routerLink]="['/invoices/control']" routerLinkActive="router-link-active">Factures à
            contrôler</a>
        </li>
        <li class="nav-item" *ngIf="showDispatched">
          <a class="nav-link" [routerLink]="['/invoices/dispatched']" routerLinkActive="router-link-active">Factures à
            traiter</a>
        </li>
        <li class="nav-item" *ngIf="showWaitingVoucher">
          <a class="nav-link" [routerLink]="['/invoices/waiting-voucher']" routerLinkActive="router-link-active">Factures en attente</a>
        </li>
        <li class="nav-item" *ngIf="showRejected">
          <a class="nav-link" [routerLink]="['/invoices/rejected']" routerLinkActive="router-link-active">Factures en
            rejet</a>
        </li>
        <li class="nav-item" *ngIf="showVoucherWorkflow">
          <a class="nav-link" [routerLink]="['/invoices/voucherworkflow']" routerLinkActive="router-link-active">Factures à valider</a>
        </li>
        <li class="nav-item" *ngIf="showPromotionWorkflow">
          <a class="nav-link" [routerLink]="['/invoices/promotionworkflow']" routerLinkActive="router-link-active">Factures à valider Promotion</a>
        </li>
        <li class="nav-item" *ngIf="showVoucherValidated">
          <a class="nav-link" [routerLink]="['/invoices/vouchervalidated']" routerLinkActive="router-link-active">Factures à comptabiliser</a>
        </li>
        <li class="nav-item" *ngIf="showInvoicesSearch">
          <a class="nav-link" [routerLink]="['/invoices/search']" routerLinkActive="router-link-active">Recherche des
            factures</a>
        </li>
        <li class="nav-item" *ngIf="showLate">
          <a class="nav-link" [routerLink]="['/invoices/late']" routerLinkActive="router-link-active">Suivi des
            factures</a>
        </li>
        <li class="nav-item dropdown" *ngIf="showAnalysis">
          <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" routerLinkActive="router-link-active" aria-haspopup="true" aria-expanded="false">
            Outils d'analyse
          </a>
          <div class="dropdown-menu" aria-labelledby="navbarDropdown">
            <a class="dropdown-item" [routerLink]="['/analysis/missing-invoice-numbers']" routerLinkActive="router-link-active">Documents à analyser</a>
            <a class="dropdown-item" [routerLink]="['/analysis/export-invoices-activity']" routerLinkActive="router-link-active">Export de l'activité</a>
          </div>
        </li>
        <li class="nav-item dropdown" *ngIf="showAdministration">
          <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" routerLinkActive="router-link-active" aria-haspopup="true" aria-expanded="false">
            Administration de l'outil
          </a>
          <div class="dropdown-menu" aria-labelledby="navbarDropdown">
            <a class="dropdown-item" [routerLink]="['/administration/users']" routerLinkActive="router-link-active">Utilisateurs</a>
            <a class="dropdown-item" [routerLink]="['/administration/groups']" routerLinkActive="router-link-active">Groupes</a>
            <a class="dropdown-item" [routerLink]="['/administration/recipient-entities']" routerLinkActive="router-link-active">Sociétés destinataires</a>
            <a class="dropdown-item" [routerLink]="['/administration/assets']" routerLinkActive="router-link-active">Références</a>
            <a class="dropdown-item" [routerLink]="['/administration/email-templates']" routerLinkActive="router-link-active">Templates email</a>
            <hr />
            <a class="dropdown-item" [routerLink]="['/administration/import-logs']" routerLinkActive="router-link-active">Historique des imports</a>
            <a class="dropdown-item" [routerLink]="['/administration/logs']" routerLinkActive="router-link-active">Logs
              administration</a>
            <a class="dropdown-item" [routerLink]="['/administration/faulted-invoice']" routerLinkActive="router-link-active">Factures en anomalie</a>
          </div>
        </li>

        <li class="nav-item dropdown" *ngIf="showAdministration">
          <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" routerLinkActive="router-link-active" aria-haspopup="true" aria-expanded="false">
            Flux de validation
          </a>
          <div class="dropdown-menu" aria-labelledby="navbarDropdown">
            <a class="dropdown-item" [routerLink]="['/administration/workflows']" routerLinkActive="router-link-active">BAP</a>
            <a class="dropdown-item" [routerLink]="['/administration/workflowsPromotion']" routerLinkActive="router-link-active">PROMOTION</a>
          </div>
        </li>

        <li class="nav-item" *ngIf="!showAdministration">
          <a class="nav-link" [routerLink]="['/administration/groups']" routerLinkActive="router-link-active">Groupes</a>
        </li>

      </ul>
      <div class="navbar-nav ml-md-auto" style="display: flex; align-items: center">
        <div class="divider"></div>
        <div fxLayoutAlign="center center" class="profile-pic">{{name_initial}}</div>
        <span class="navbar-text">
          {{name}}
        </span>
        <mat-icon
            class="material-icons-outlined"
            style="width: 30px; height: 30px; font-size: 30px;"
            (click)='logout()'
            title="Déconnexion de eFac">
            exit_to_app
        </mat-icon>
      </div>
    </div>
  </nav>
</header>
